import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const FivePointStar = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="90" viewBox="0 0 90 86" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M45.0279 0.461716L55.6407 33.1257H89.9857L62.2004 53.3136L72.8132 85.9776L45.0279 65.7897L17.2417 85.9776L27.8554 53.3136L0.069191 33.1257H34.4142L45.0279 0.461716Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
